import { render, staticRenderFns } from "./riskOnePage.vue?vue&type=template&id=077b5c81"
import script from "./riskOnePage.vue?vue&type=script&lang=js"
export * from "./riskOnePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('077b5c81')) {
      api.createRecord('077b5c81', component.options)
    } else {
      api.reload('077b5c81', component.options)
    }
    module.hot.accept("./riskOnePage.vue?vue&type=template&id=077b5c81", function () {
      api.rerender('077b5c81', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ram/riskOnePage.vue"
export default component.exports